<app-windowlist [model]="this">
    <div class="card elevation-0 border-0 mb-0">
        <div class="row d-none d-lg-flex my-3">
            <div class="col-12">
                <i class="float-left text-gray px-2 fas fa-question-circle fa-2x"></i>
                <div class="float-left">
                    <small>
                        Clicca sul pulsante <i class="fa fa-plus"></i> per creare un nuovo gruppo di anagrafiche a cui poter inviare <b>notifiche</b>.<br>
                        Il gruppo è costituito dalle anagrafiche degli elementi visualizzati in tabella (ovvero con i <b>filtri di ricerca</b> impostati).
                    </small>
                </div>
            </div>
        </div>
        <div class="row">            
            <div class="col-lg-9">
                <div class="input-group input-group-sm p-1">
                    <input type="text" #table_search name="table_search" class="form-control form-control-sm" placeholder="Cerca ..." [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''">
                    <div class="input-group-append ">
                        <button type="submit" class="btn btn-default text-primary" title="Avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                        <button class="btn btn-default text-danger" title="Annulla ricerca" *ngIf="filter_search.value!=''" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="mr-1">
                    <app-windowlistbuttons 
                        [model]="this" 
                        [table]="'userslist'"
                        [showSaveListUser]="false" 
                        [showNotify]="false"
                        ></app-windowlistbuttons>
                </div>                
            </div>
        </div>
         <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
            <i class="far fa-meh mr-2"></i><i>Nessun gruppo da visualizzare!</i>
        </div>
        <form [formGroup]="form" *ngIf="list && list.length>0">
            <table class="table table-sm table-striped text-nowrap m-0" >
                <thead>
                    <!-- <th>
                        <div #checkboxselectall class="icheck-primary d-inline mr-1">
                            <input type="checkbox" title="Seleziona tutti"
                            (change)="onChangeAll($event.target.checked);" />
                        </div>
                    </th> -->
                    <th>Nome</th>
                    <th>Tabella</th>
                    <th></th>
                </thead>
                <tbody>

                    <!-- elemento ripetuto -->
                    <ng-container *ngFor="let record of list">
                        <tr>
                            <!-- <td>
                                <div class="icheck-primary d-inline mr-1">
                                    <input type="checkbox" #checkrecord id_record="{{record.id}}" title="ID: {{record.id}}" 
                                    (change)="onChange(record.id, $event.target.checked);" [checked]="checkedAll"
                                    />
                                </div>
                            </td> -->
                            <td><b>{{record.name}}</b></td>
                            <td><small><i><app-selecttables [value]="record.table" [no_select]="true"></app-selecttables></i></small></td>
                            <td class="pr-2">                                
                                <button type="button" *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right" (click)="selectRecord(record);">
                                    <span class="d-none d-sm-inline-block">Aggiorna</span><i class="fas fa-chevron-right ml-1"></i></button>
                                <button type="button" *ngIf="currentUser.isSuperUser()" title="Elimina" class="btn btn-danger btn-xs float-right ml-1" (click)="confirm_delete(record)">
                                    <i class="fa fa-trash"></i></button>
                                <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)" title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right ml-1">
                                    <i class="fas fa-pencil-alt"></i></button>
                                <button type="button" *ngIf="mode!='modal'"  (click)="notify(record);" title="Notifica" class="btn btn-primary btn-xs float-right ml-1">
                                    <i class="far fa-paper-plane"></i></button>
                                
                            </td>
                        </tr>
                    </ng-container>

                </tbody>
            </table>
        </form>
        <div class="card-footer clearfix py-1">
            <app-pagination [model]="this" ></app-pagination>
        </div>
    </div>

</app-windowlist>